import styled from "styled-components";
import { ProcessingCircle } from "../ProcessingCircle";

const OutlineButton = styled.button<{
  fullWidth: boolean;
  noIconFill: boolean;
  extraSmall: boolean;
}>`
  display: flex;
  height: 46px;
  padding: 12px 16px;
  @media screen and (max-width: 360px) {
    padding: 10px 12px;
    font-size: 12px;
    font-weight: 500;
    line-height: 16.8px;
    height: unset;
    ${(props) => (props.extraSmall ? "padding: 0;" : "")}
  }
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  color: #ff6d34;
  border: 2px solid #ff6d34;
  background: transparent;
  font-size: 16px;
  font-weight: 500;
  line-height: 20.8px;
  width: ${(props) => (props.fullWidth ? "100%" : "auto")};
  transition: all 0.2s ease-in-out;
  ${(props) =>
    props.extraSmall
      ? `
    width: 28px;
    height: 28px; 
    padding: 0;
    border-radius: 4px;
    border: 1px solid #FF6D34;
  `
      : ""}
  svg {
    ${(props) => (props.noIconFill ? "" : "fill: #FF6D34")};
    transition: fill 0.2s ease-in-out;
  }
  white-space: nowrap;

  &:disabled {
    border: ${(props) => (props.extraSmall ? "1px" : "2px")} solid #c1c1c1;
    background: #ebebeb;
    color: #c1c1c1;
    ${(props) => (props.noIconFill ? "" : "svg { fill: #C1C1C1 }")};
    svg {
      path {
        stroke: #c1c1c1;
      }
    }
    &:hover {
      border: ${(props) => (props.extraSmall ? "1px" : "2px")} solid #c1c1c1;
      background: #ebebeb;
      color: #c1c1c1;
    }
  }

  &:hover {
    border: ${(props) => (props.extraSmall ? "1px" : "2px")} solid #ff510e;
    background: #fff7f4;
  }
`;

interface BtnProps {
  children: React.ReactNode;
  fullWidth?: boolean;
  tooltip?: string;
  noIconFill?: boolean;
  extraSmall?: boolean;
  loading?: boolean;
  [key: string]: any;
}

export const SecondaryButton: React.FC<BtnProps> = ({
  children,
  fullWidth = false,
  tooltip = "",
  noIconFill = false,
  extraSmall = false,
  loading = false,
  ...nativeButtonProps
}) => (
  <OutlineButton
    fullWidth={fullWidth}
    title={tooltip}
    type={nativeButtonProps?.type || "button"}
    noIconFill={noIconFill}
    extraSmall={extraSmall}
    {...nativeButtonProps}
  >
    {!loading && children}
    {loading && <ProcessingCircle circleSize="20px" />}
  </OutlineButton>
);
